//  /////////////// COPYRIGHT © 2025/2026 IROÏD/DSTRKT™ FOR TIXFORGIGS
//  ////////////////////////////////////////////// ALL RIGHTS RESERVED
//  /////// LICENSED UNDER THE IROÏD LICENSE VERSION 1.0 [THE LICENSE]
//  /////// DO NOT USE THIS FILE EXCEPT IN COMPLIANCE WITH THE LICENSE
//
//  TixforGigs™ Unified API
//
//  VERSION: 4.6
//  PACKAGE: 4.6.297-SNAPSHOT
//  CONTACT: developer@tixforgigs.com
//  CREATED: 2026-02-26T01:20:10.489677Z
//
//  /////////////////////////////////////// AUTOGENERATED. DO NOT EDIT

@file:Suppress(
  "ArrayInDataClass",
  "EnumEntryName",
  "RemoveRedundantQualifierName",
  "UnusedImport"
)

package com.tixforgigs.apax.models


        import kotlinx.serialization.*

/**
* The item type id
*
* 
*  * E_TICKET value: 1 - e-ticket (SelfTix) 
*  * SYS_TIX value: 2 - SysTix 
*  * HARD_TIX value: 3 - FanTix+ - external printed tickets 
*  * ADVANCE_PAYMENT value: 4 - AdvancePayment 
*  * REFUND value: 5 - Refund 
*  * COST value: 6 - Cost 
*  * CREDIT value: 7 - Credit 
*  * FAN_TIX value: 8 - FanTix 
*  * TICKET_PRICE_ADDITION value: 9 - TicketPriceAddition - e.g. club euro? 
*  * FREE_INVOICE_COST value: 10 - FreeInvoiceCost 
*  * FREE_INVOICE_CREDIT value: 11 - FreeInvoiceCredit 
*  * PRESALE_TIX value: 12 - VVKTix 
*  * SYSTEM_FEE value: 13 - SystemFee 
*  * KOMBI_TICKET value: 14 - KombiTicket - ticket + ÖPNV 
*  * TICKET_IMPORT value: 15 - TicketImport 
*  * SCANNER_RENTAL value: 16 - ScannerRental 
*  * SCANNER_RETURN_FORM value: 17 - ScannerReturnForm 
*  * ORDER_BOOKING_FEE value: 18 - OrderBookingFee 
*  * STREAM_TIX value: 19 - StreamTix 
*/
@Serializable
enum class ItemTypeId(val value: kotlin.Int) {

    @SerialName(value = "1")
    E_TICKET(1),

    @SerialName(value = "2")
    SYS_TIX(2),

    @SerialName(value = "3")
    HARD_TIX(3),

    @SerialName(value = "4")
    ADVANCE_PAYMENT(4),

    @SerialName(value = "5")
    REFUND(5),

    @SerialName(value = "6")
    COST(6),

    @SerialName(value = "7")
    CREDIT(7),

    @SerialName(value = "8")
    FAN_TIX(8),

    @SerialName(value = "9")
    TICKET_PRICE_ADDITION(9),

    @SerialName(value = "10")
    FREE_INVOICE_COST(10),

    @SerialName(value = "11")
    FREE_INVOICE_CREDIT(11),

    @SerialName(value = "12")
    PRESALE_TIX(12),

    @SerialName(value = "13")
    SYSTEM_FEE(13),

    @SerialName(value = "14")
    KOMBI_TICKET(14),

    @SerialName(value = "15")
    TICKET_IMPORT(15),

    @SerialName(value = "16")
    SCANNER_RENTAL(16),

    @SerialName(value = "17")
    SCANNER_RETURN_FORM(17),

    @SerialName(value = "18")
    ORDER_BOOKING_FEE(18),

    @SerialName(value = "19")
    STREAM_TIX(19);

  /**
  * Override [toString()] to avoid using the enum variable name as the value, and instead use
  * the actual value defined in the API spec file.
  *
  * This solves a problem when the variable name and its value are different, and ensures that
  * the client sends the correct enum values to the server always.
  */
  override fun toString(): kotlin.String = value.toString()

  companion object {
    /**
    * Converts the provided [data] to a [String] on success, null otherwise.
    */
    fun encode(data: kotlin.Any?): kotlin.String? = if (data is ItemTypeId) "$data" else null

    /**
    * Returns a valid [ItemTypeId] for [data], null otherwise.
    */
    fun decode(data: kotlin.Any?): ItemTypeId? = data?.let {
      val normalizedData = "$it".lowercase()
      values().firstOrNull { value ->
        it == value || normalizedData == "$value".lowercase()
      }
    }
  }
}

